import { Country } from '@/src/types/apps/resto365Countries'
import { getCountryFromStr } from './session'

type locale = 'en-AU'

let selectedLocale: locale = 'en-AU'
let selectedLocalCountryCode: Country = Country.AUS

const setSessionLocale = (country: Country) => {
  selectedLocale = 'en-AU'
  selectedLocalCountryCode = getCountryFromStr(country)
}

const currencyFormat = (amount: number | undefined) => {
  if (amount === undefined || amount === null) {
    return
  }

  return new Intl.NumberFormat(selectedLocale, {
    style: 'currency',
    currency: 'AUD'
  })
    .format(amount)
    .replace('.00', '')
}

const percentageFormat = (amount: number | undefined) => {
  if (!amount) {
    return
  }

  return `${amount}%`
}

export { setSessionLocale, selectedLocale, selectedLocalCountryCode, currencyFormat, percentageFormat }
